var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { BigNumber } from "@ethersproject/bignumber";
import { getAssetDecimals } from "../utils/asset";
import { CHAINID, SUBGRAPH_URI, getSubgraphqlURI, isDevelopment, isProduction, isTreasury, getSolanaAddresses, SOLANA_SUBGRAPH, } from "../utils/env";
import { PublicKey } from "@solana/web3.js";
import v1deployment from "./v1Deployments.json";
import v2deployment from "./vvDeployments.json";
import governanceDeployment from "./governanceDeployment.json";
import addresses from "./externalAddresses.json";
export var Chains;
(function (Chains) {
    Chains[Chains["NotSelected"] = 0] = "NotSelected";
    Chains[Chains["Ethereum"] = 1] = "Ethereum";
    Chains[Chains["Avalanche"] = 2] = "Avalanche";
    Chains[Chains["Solana"] = 3] = "Solana";
    Chains[Chains["BSC"] = 4] = "BSC";
})(Chains || (Chains = {}));
export var NETWORKS = (_a = {},
    _a[CHAINID.ETH_MAINNET] = "mainnet",
    _a[CHAINID.ETH_KOVAN] = "kovan",
    _a[CHAINID.AVAX_FUJI] = "fuji",
    _a[CHAINID.AVAX_MAINNET] = "avax",
    _a[CHAINID.BSC_MAINNET] = "bsc",
    _a[CHAINID.BSC_TEST] = "bsctest",
    _a);
export var CHAINID_TO_NATIVE_TOKENS = (_b = {},
    _b[CHAINID.ETH_MAINNET] = "WETH",
    _b[CHAINID.ETH_ROPSTEN] = "WETH",
    _b[CHAINID.ETH_RINKEBY] = "WETH",
    _b[CHAINID.ETH_GOERLI] = "WETH",
    _b[CHAINID.ETH_KOVAN] = "WETH",
    _b[CHAINID.HECO_TEST] = "WETH",
    _b[CHAINID.HECO_MAINNET] = "WETH",
    _b[CHAINID.AVAX_MAINNET] = "WETH",
    _b[CHAINID.AVAX_FUJI] = "WETH",
    _b[CHAINID.BSC_MAINNET] = "WETH",
    _b[CHAINID.BSC_TEST] = "WETH",
    // [CHAINID.HECO_TEST]: "WHT",
    // [CHAINID.HECO_MAINNET]: "WHT",
    // [CHAINID.AVAX_MAINNET]: "WAVAX",
    // [CHAINID.AVAX_FUJI]: "WAVAX",
    // [CHAINID.BSC_MAINNET]: "WBNB",
    // [CHAINID.BSC_TEST]: "WBNB",
    _b[CHAINID.O] = "WETH",
    _b[CHAINID.ARBITRUM] = "WETH",
    _b[CHAINID.POLYGON] = "WETH",
    _b);
export var READABLE_NETWORK_NAMES = (_c = {},
    _c[CHAINID.ETH_MAINNET] = "Ethereum",
    _c[CHAINID.ETH_ROPSTEN] = "Ropsten",
    _c[CHAINID.ETH_RINKEBY] = "Rinkeby",
    _c[CHAINID.ETH_GOERLI] = "Goerli",
    _c[CHAINID.ETH_KOVAN] = "Kovan",
    _c[CHAINID.HECO_TEST] = "HecoTest",
    _c[CHAINID.HECO_MAINNET] = "Heco",
    _c[CHAINID.AVAX_MAINNET] = "Avalanche",
    _c[CHAINID.AVAX_FUJI] = "Fuji",
    _c[CHAINID.BSC_MAINNET] = "BSC",
    _c[CHAINID.BSC_TEST] = "BSC Test",
    _c[CHAINID.O] = "O3",
    _c[CHAINID.ARBITRUM] = "Arbitrum",
    _c[CHAINID.POLYGON] = "Polygon",
    _c);
export var isBscNetwork = function (chainId) {
    return chainId === CHAINID.BSC_MAINNET || chainId === CHAINID.BSC_TEST;
};
export var isEthNetwork = function (chainId) {
    return chainId === CHAINID.ETH_MAINNET || chainId === CHAINID.ETH_KOVAN;
};
export var isAvaxNetwork = function (chainId) {
    return chainId === CHAINID.AVAX_MAINNET || chainId === CHAINID.AVAX_FUJI;
};
export var isBscVault = function (vault) { var _a; return isBscNetwork((_a = VaultAddressMap[vault]) === null || _a === void 0 ? void 0 : _a.chainId); };
export var isEthVault = function (vault) { var _a; return isEthNetwork((_a = VaultAddressMap[vault]) === null || _a === void 0 ? void 0 : _a.chainId); };
export var isAvaxVault = function (vault) { var _a; return isAvaxNetwork((_a = VaultAddressMap[vault]) === null || _a === void 0 ? void 0 : _a.chainId); };
export var getVaultChain = function (vault) {
    if (isEthVault(vault))
        return Chains.Ethereum;
    else if (isBscVault(vault))
        return Chains.BSC;
    else if (isAvaxVault(vault))
        return Chains.Avalanche;
    else if (isSolanaVault(vault))
        return Chains.Solana;
    // else throw new Error(`Unknown network for ${vault}`);
    else
        return Chains.NotSelected;
};
export var getVaultNetwork = function (vault) {
    if (isEthVault(vault))
        return "mainnet";
    else if (isBscVault(vault))
        return "bsc";
    else if (isAvaxVault(vault))
        return "avax";
    else
        throw new Error("Unknown network for " + vault);
};
// export const NATIVE_TOKENS = ["WETH", "WAVAX", "SOL", "WBNB"];
export var NATIVE_TOKENS = ["BNB"];
export var isNativeToken = function (token) {
    return NATIVE_TOKENS.includes(token);
};
export var VaultVersionList = ["v2", "v1"];
export var EVMVaultList = [
    // "bETH-THETA",
    // "bBTC-THETA",
    // "bBUSD-ETH-P-THETA",
    "bBNB-THETA"
    // "rAPE-THETA",
    // "rsAVAX-THETA",
    // "rBUSD-AVAX-P-THETA",
    // "ryvUSDC-ETH-P-THETA",
    // "rstETH-THETA",
    // "rAVAX-THETA",
    // "rAAVE-THETA",
];
// export const SolanaVaultList = ["rSOL-THETA"] as const;
export var SolanaVaultList = [];
export var RetailVaultList = __spreadArray(__spreadArray([], SolanaVaultList), EVMVaultList);
// export const TreasuryVaultList = ["rPERP-TSRY"] as const;
export var TreasuryVaultList = [];
var AllVaultOptions = __spreadArray(__spreadArray(__spreadArray([], EVMVaultList), TreasuryVaultList), SolanaVaultList);
var ProdExcludeVault = [];
var PutThetaVault = [
// "bBUSD-ETH-P-THETA",
// "ryvUSDC-ETH-P-THETA",
// "rBUSD-AVAX-P-THETA",
];
export var SolanaAssets = ["SOL"];
export var isSolanaVault = function (vaultOption) {
    var list = SolanaVaultList;
    return list.includes(vaultOption);
};
export var isSolanaAsset = function (asset) { return SolanaAssets.includes(asset); };
export var StakingVaultList = EVMVaultList;
// @ts-ignore
export var VaultList = isTreasury()
    ? TreasuryVaultList
    : !isProduction()
        ? RetailVaultList
        : RetailVaultList.filter(function (vault) { return !ProdExcludeVault.includes(vault); });
// export const VaultList: VaultOptions[] =[
//   "bETH-THETA",
//   "bBUSD-ETH-P-THETA",
//   "bBTC-THETA",
// ]
export var GAS_LIMITS = {
    // "bETH-THETA": {
    //   v1: {
    //     deposit: 80000,
    //     withdraw: 100000,
    //   },
    //   v2: {
    //     deposit: 120000,
    //     withdrawInstantly: 120000,
    //     completeWithdraw: 300000,
    //   },
    // },
    // "bBTC-THETA": {
    //   v1: {
    //     deposit: 100000,
    //     withdraw: 140000,
    //   },
    //   v2: {
    //     deposit: 140000,
    //     withdrawInstantly: 120000,
    //     completeWithdraw: 300000,
    //   },
    // },
    "bBNB-THETA": {
        v1: {
            deposit: 100000,
            withdraw: 140000,
        },
        v2: {
            deposit: 140000,
            withdrawInstantly: 120000,
            completeWithdraw: 300000
        }
    },
    // "bBUSD-ETH-P-THETA": {
    //   v1: {
    //     deposit: 120000,
    //     withdraw: 120000,
    //   },
    //   v2: {
    //     deposit: 140000,
    //     withdrawInstantly: 120000,
    //     completeWithdraw: 300000,
    //   },
    // },
    // "ryvUSDC-ETH-P-THETA": {
    //   v1: {
    //     deposit: 210000,
    //     withdraw: 210000,
    //   },
    //   v2: {
    //     deposit: 140000,
    //     withdrawInstantly: 120000,
    //     completeWithdraw: 300000,
    //   },
    // },
    // "rstETH-THETA": {
    //   v2: {
    //     deposit: 170000,
    //     withdrawInstantly: 130000,
    //     completeWithdraw: 400000,
    //   },
    // },
    // "rAAVE-THETA": {
    //   v2: {
    //     deposit: 380000,
    //     withdrawInstantly: 130000,
    //     completeWithdraw: 300000,
    //   },
    // },
    // "rAVAX-THETA": {
    //   v2: {
    //     deposit: 380000,
    //     withdrawInstantly: 130000,
    //     completeWithdraw: 300000,
    //   },
    // },
    // "rsAVAX-THETA": {
    //   v2: {
    //     deposit: 380000,
    //     withdrawInstantly: 130000,
    //     completeWithdraw: 300000,
    //   },
    // },
    // "rBUSD-AVAX-P-THETA": {
    //   v2: {
    //     deposit: 140000,
    //     withdrawInstantly: 120000,
    //     completeWithdraw: 300000,
    //   },
    // },
    // "rPERP-TSRY": {
    //   v2: {
    //     deposit: 380000,
    //     withdrawInstantly: 130000,
    //     completeWithdraw: 300000,
    //   },
    // },
    // "rSOL-THETA": {
    //   v2: {
    //     deposit: 380000,
    //     withdrawInstantly: 130000,
    //     completeWithdraw: 300000,
    //   },
    // },
    // "rAPE-THETA": {
    //   v2: {
    //     deposit: 380000,
    //     withdrawInstantly: 130000,
    //     completeWithdraw: 300000,
    //   },
    // },
};
/**
 * lm: Liquidity Mining round during July 2021
 * lg5: Liquidity Gauge V4 from curve.fi
 */
export var LiquidityMiningVersionList = ["lg5", "lm"];
var ProdExcludeLiquidityMiningVersion = [];
// @ts-ignore
export var OngoingLMVersion = !isProduction()
    ? LiquidityMiningVersionList
    : LiquidityMiningVersionList.filter(function (lm) { return !ProdExcludeLiquidityMiningVersion.includes(lm); });
export var VaultLiquidityMiningMap = isDevelopment()
    ? {
        lm: {
            // "bBUSD-ETH-P-THETA": v1deployment.kovan.RibbonETHPutStakingReward,
            // "bBTC-THETA": v1deployment.kovan.RibbonWBTCCoveredCallStakingReward,
            // "bETH-THETA": v1deployment.kovan.RibbonETHCoveredCallStakingReward,
            "bBNB-THETA": undefined
        },
        lg5: {
            // "bBUSD-ETH-P-THETA": v2deployment.bsctest.RibbonETHPutLiquidityGauge,
            // "bETH-THETA": v2deployment.bsctest.RibbonETHCoveredCallLiquidityGauge,
            // "bBTC-THETA": v2deployment.bsctest.RibbonWBTCCoveredCallLiquidityGauge,
            "bBNB-THETA": undefined
        },
    }
    : {
        lm: {
            // "bBUSD-ETH-P-THETA": v1deployment.mainnet.RibbonETHPutStakingReward,
            // "bBTC-THETA": v1deployment.mainnet.RibbonWBTCCoveredCallStakingReward,
            // "bETH-THETA": v1deployment.mainnet.RibbonETHCoveredCallStakingReward,
            "bBNB-THETA": undefined
        },
        lg5: {
            // "ryvUSDC-ETH-P-THETA":
            //   v2deployment.mainnet.RibbonYearnETHPutLiquidityGauge,
            // "rAAVE-THETA": v2deployment.mainnet.RibbonAAVECoveredCallLiquidityGauge,
            // "rstETH-THETA": v2deployment.mainnet.RibbonSTETHCoveredLiquidityGauge,
            // "bBUSD-ETH-P-THETA": v2deployment.bsc.RibbonETHPutLiquidityGauge,
            // "bETH-THETA": v2deployment.bsc.RibbonETHCoveredCallLiquidityGauge,
            // "bBTC-THETA": v2deployment.bsc.RibbonWBTCCoveredCallLiquidityGauge,
            "bBNB-THETA": undefined
        },
    };
export var isPutVault = function (vault) {
    return PutThetaVault.includes(vault);
};
export var VaultAddressMap = {
    // "bBUSD-ETH-P-THETA": isDevelopment()
    //   ? {
    //     v1: v1deployment.kovan.RibbonETHPut,
    //     v2: v2deployment.kovan.RibbonThetaVaultETHPut,
    //     chainId: CHAINID.ETH_KOVAN,
    //   }
    //   : {
    //     v1: v1deployment.mainnet.RibbonETHPut,
    //     chainId: CHAINID.ETH_MAINNET,
    //   },
    // "bBUSD-ETH-P-THETA": isDevelopment()
    //   ? {
    //     v1: undefined,
    //     v2: v2deployment.bsctest.RibbonThetaVaultETHPut,
    //     chainId: CHAINID.BSC_TEST,
    //   }
    //   : {
    //     v2: v2deployment.bsc.RibbonThetaVaultETHPut,
    //     chainId: CHAINID.BSC_MAINNET,
    //   },
    // "bETH-THETA": isDevelopment()
    //   ? {
    //     v1: v1deployment.kovan.RibbonETHCoveredCall,
    //     v2: v2deployment.kovan.RibbonThetaVaultETHCall,
    //     chainId: CHAINID.ETH_KOVAN,
    //   }
    //   : {
    //     v1: v1deployment.mainnet.RibbonETHCoveredCall,
    //     v2: v2deployment.mainnet.RibbonThetaVaultETHCall,
    //     chainId: CHAINID.ETH_MAINNET,
    //   },
    // "bETH-THETA": isDevelopment()
    //   ? {
    //     v1: undefined,
    //     v2: v2deployment.bsctest.RibbonThetaVaultETHCall,
    //     chainId: CHAINID.BSC_TEST,
    //   }
    //   : {
    //     v1: v1deployment.mainnet.RibbonETHCoveredCall,
    //     v2: v2deployment.bsc.RibbonThetaVaultETHCall,
    //     chainId: CHAINID.BSC_MAINNET,
    //   },
    // "bBTC-THETA": isDevelopment()
    //   ? {
    //     v1: v1deployment.kovan.RibbonWBTCCoveredCall,
    //     v2: v2deployment.kovan.RibbonThetaVaultWBTCCall,
    //     chainId: CHAINID.ETH_KOVAN,
    //   }
    //   : {
    //     v1: v1deployment.mainnet.RibbonWBTCCoveredCall,
    //     v2: v2deployment.mainnet.RibbonThetaVaultWBTCCall,
    //     chainId: CHAINID.ETH_MAINNET,
    //   },
    // "bBTC-THETA": isDevelopment()
    //   ? {
    //     v1: undefined,
    //     v2: v2deployment.bsctest.RibbonThetaVaultWBTCCall,
    //     chainId: CHAINID.BSC_TEST,
    //   }
    //   : {
    //     v1: v1deployment.mainnet.RibbonWBTCCoveredCall,
    //     v2: v2deployment.bsc.RibbonThetaVaultWBTCCall,
    //     chainId: CHAINID.BSC_MAINNET,
    //   },
    "bBNB-THETA": isDevelopment()
        ? {
            v1: undefined,
            v2: undefined,
            chainId: CHAINID.BSC_TEST,
        }
        : {
            v1: undefined,
            v2: v2deployment.bsc.RibbonThetaVaultWBNBCall,
            chainId: CHAINID.BSC_MAINNET,
        },
    // "ryvUSDC-ETH-P-THETA": isDevelopment()
    //   ? {
    //     v1: v1deployment.kovan.RibbonYearnETHPut,
    //     chainId: CHAINID.ETH_KOVAN,
    //   }
    //   : {
    //     v1: v1deployment.mainnet.RibbonYearnETHPut,
    //     v2: v2deployment.mainnet.RibbonThetaYearnVaultETHPut,
    //     chainId: CHAINID.ETH_MAINNET,
    //   },
    // "rstETH-THETA": isDevelopment()
    //   ? {
    //     /**
    //      * We use ETH vault for Kovan preview
    //      */
    //     v2: v2deployment.kovan.RibbonThetaVaultETHCall,
    //     chainId: CHAINID.ETH_KOVAN,
    //   }
    //   : {
    //     v2: v2deployment.mainnet.RibbonThetaVaultSTETHCall,
    //     chainId: CHAINID.ETH_MAINNET,
    //   },
    // "rAAVE-THETA": isDevelopment()
    //   ? {
    //     /**
    //      * We use ETH vault for Kovan preview
    //      */
    //     v2: v2deployment.kovan.RibbonThetaVaultETHCall,
    //     chainId: CHAINID.ETH_KOVAN,
    //   }
    //   : {
    //     v2: v2deployment.mainnet.RibbonThetaVaultAAVECall,
    //     chainId: CHAINID.ETH_MAINNET,
    //   },
    // "rAVAX-THETA": isDevelopment()
    //   ? {
    //     v2: v2deployment.fuji.RibbonThetaVaultAVAXCall,
    //     chainId: CHAINID.AVAX_FUJI,
    //   }
    //   : {
    //     v2: v2deployment.avax.RibbonThetaVaultAVAXCall,
    //     chainId: CHAINID.AVAX_MAINNET,
    //   },
    // "rsAVAX-THETA": isDevelopment()
    //   ? {
    //     v2: v2deployment.fuji.RibbonThetaVaultSAVAXCall,
    //     chainId: CHAINID.AVAX_FUJI,
    //   }
    //   : {
    //     v2: v2deployment.avax.RibbonThetaVaultSAVAXCall,
    //     chainId: CHAINID.AVAX_MAINNET,
    //   },
    // "rBUSD-AVAX-P-THETA": isDevelopment()
    //   ? {
    //     // v2: v2deployment.avax.RibbonThetaVaultAVAXPut,
    //     v2: v2deployment.bsctest.RibbonThetaVaultETHPut,
    //     chainId: CHAINID.AVAX_FUJI,
    //   }
    //   : {
    //     // v2: v2deployment.avax.RibbonThetaVaultAVAXPut,
    //     v2: v2deployment.bsctest.RibbonThetaVaultETHPut,
    //     chainId: CHAINID.AVAX_MAINNET,
    //   },
    // "rPERP-TSRY": isDevelopment()
    //   ? {
    //     v2: v2deployment.kovan.RibbonTreasuryVaultPERP,
    //     chainId: CHAINID.ETH_KOVAN,
    //   }
    //   : {
    //     v2: v2deployment.mainnet.RibbonTreasuryVaultPERP,
    //     chainId: CHAINID.ETH_MAINNET,
    //   },
    // FIXME: change with real addresses
    // "rSOL-THETA": {
    //   v2: getSolanaAddresses().vaults["rSOL-THETA"],
    //   chainId: 99999999, // we stub this out with a fake chainid
    // },
    // "rAPE-THETA": {
    //   v2: v2deployment.mainnet.RibbonThetaVaultAPECall,
    //   chainId: CHAINID.ETH_MAINNET,
    // },
};
/**
 * Used to check if vault of given version exists. Only used for v2 and above
 * @param vaultOption
 * @returns boolean
 */
export var hasVaultVersion = function (vaultOption, version) {
    return Boolean(VaultAddressMap[vaultOption][version]);
};
export var VaultNamesList = [
    // "ETH Covered Put",
    // "ETH Covered Call",
    // "BTC Covered Call",
    "BNB Covered Call"
    // "T-yvUSDC-P-ETH",
    // "T-stETH-C",
    // "T-AAVE-C",
    // "T-AVAX-C",
    // "T-sAVAX-C",
    // "T-BUSD-P-ETH",
    // "T-PERP-C",
    // "T-SOL-C",
    // "T-APE-C",
];
export var VaultNameOptionMap = {
    // "ETH Covered Put": "bBUSD-ETH-P-THETA",
    // "ETH Covered Call": "bETH-THETA",
    // "BTC Covered Call": "bBTC-THETA",
    "BNB Covered Call": "bBNB-THETA"
    // "T-yvUSDC-P-ETH": "ryvUSDC-ETH-P-THETA",
    // "T-stETH-C": "rstETH-THETA",
    // "T-AAVE-C": "rAAVE-THETA",
    // "T-AVAX-C": "rAVAX-THETA",
    // "T-sAVAX-C": "rsAVAX-THETA",
    // "T-BUSD-P-ETH": "rBUSD-AVAX-P-THETA",
    // "T-PERP-C": "rPERP-TSRY",
    // "T-SOL-C": "rSOL-THETA",
    // "T-APE-C": "rAPE-THETA",
};
// Reverse lookup for VaultNameOptionMap
export var vaultOptionToName = function (option) {
    var match = Object.entries(VaultNameOptionMap).find(function (_a) {
        var name = _a[0], optionName = _a[1];
        return optionName === option;
    });
    if (match) {
        return match[0];
    }
    return undefined;
};
export var EVM_BLOCKCHAIN_EXPLORER_NAME = (_d = {},
    _d[CHAINID.ETH_MAINNET] = "Etherscan",
    _d[CHAINID.ETH_KOVAN] = "Etherscan",
    _d[CHAINID.AVAX_MAINNET] = "SnowTrace",
    _d[CHAINID.AVAX_FUJI] = "SnowTrace",
    _d[CHAINID.BSC_MAINNET] = "Bscscan",
    _d[CHAINID.BSC_TEST] = "Bscscan",
    _d);
export var EVM_BLOCKCHAIN_EXPLORER_URI = (_e = {},
    _e[CHAINID.ETH_MAINNET] = "https://etherscan.io",
    _e[CHAINID.ETH_KOVAN] = "https://kovan.etherscan.io",
    _e[CHAINID.AVAX_MAINNET] = "https://snowtrace.io",
    _e[CHAINID.AVAX_FUJI] = "https://testnet.snowtrace.io",
    _e[CHAINID.BSC_MAINNET] = "https://bscscan.com",
    _e[CHAINID.BSC_TEST] = "https://testnet.bscscan.com",
    _e);
export var AVAX_BRIDGE_URI = "https://bridge.avax.network";
export var getExplorerName = function (chain) {
    if (chain === Chains.Solana) {
        return "Solscan";
    }
    return EVM_BLOCKCHAIN_EXPLORER_NAME[CHAINS_TO_ID[chain]];
};
// Left here for compatibility purposes
export var getEtherscanURI = function (chainId) {
    return EVM_BLOCKCHAIN_EXPLORER_URI[chainId];
};
export var getExplorerURI = function (chain) {
    if (chain === Chains.Solana) {
        return "https://solscan.io";
    }
    return EVM_BLOCKCHAIN_EXPLORER_URI[CHAINS_TO_ID[chain]];
};
export var getSubgraphURIForVersion = function (version, chain) {
    // console.log('--------chain---------')
    // console.log(version, '--------chain---------', chain)
    // console.log(SUBGRAPH_URI[CHAINS_TO_ID[chain]]);
    switch (version) {
        case "v1":
            return getSubgraphqlURI();
        case "v2":
            switch (chain) {
                // case Chains.Ethereum:
                // case Chains.Avalanche:
                case Chains.BSC:
                    return SUBGRAPH_URI[CHAINS_TO_ID[chain]];
                case Chains.Solana:
                    return SOLANA_SUBGRAPH;
                default:
                    throw new Error("No found subgraph");
            }
    }
};
export var getAssets = function (vault) {
    switch (vault) {
        // case "bBUSD-ETH-P-THETA":
        //   return "USDC";
        // case "bBTC-THETA":
        //   return "WBTC";
        // case "bETH-THETA":
        //   return "WETH";
        // case "bBUSD-ETH-P-THETA":
        //   return "USDC";
        // case "bETH-THETA":
        //   return "WETH";
        case "bBNB-THETA":
            return "WBNB";
        // case "rAAVE-THETA":
        //   return "AAVE";
        // case "rAVAX-THETA":
        //   return "WAVAX";
        // case "rsAVAX-THETA":
        //   return "sAVAX";
        // case "rPERP-TSRY":
        //   return "PERP";
        // case "rSOL-THETA":
        //   return "SOL";
        // case "rAPE-THETA":
        //   return "APE";
    }
};
export var getAssetsBackup = function (vault) {
    switch (vault) {
        case "bBNB-THETA":
            return "BNB";
    }
};
export var getOptionAssets = function (vault) {
    switch (vault) {
        // case "bBTC-THETA":
        //   return "WBTC";
        // case "bETH-THETA":
        //   return "WETH";
        // case "bBUSD-ETH-P-THETA":
        //   return "ETH";
        case "bBNB-THETA":
            return "WBNB";
    }
};
export var getDisplayAssets = function (vault) {
    switch (vault) {
        // case "bBUSD-ETH-P-THETA":
        //   return "USDC";
        // case "bETH-THETA":
        //   return "WETH";
        // case "bBTC-THETA":
        //   return "WBTC";
        case "bBNB-THETA":
            return "WBNB";
    }
};
export var VaultAllowedDepositAssets = {
    // "bBTC-THETA": ["WBTC"],
    // "bETH-THETA": ["WETH"],
    // "bBUSD-ETH-P-THETA": ["USDC"],
    "bBNB-THETA": ["WBNB"]
};
export var VaultAllowedDepositAssetsBackup = {
    // "bBTC-THETA": ["WBTC"],
    // "bETH-THETA": ["WETH"],
    // "bBUSD-ETH-P-THETA": ["USDC"],
    "bBNB-THETA": ["BNB"]
};
export var VaultMaxDeposit = {
    // "bBUSD-ETH-P-THETA": BigNumber.from(100000000).mul(
    //   BigNumber.from(10).pow(getAssetDecimals(getAssets("bBUSD-ETH-P-THETA")))
    // ),
    // "bETH-THETA": BigNumber.from(50000).mul(
    //   BigNumber.from(10).pow(getAssetDecimals(getAssets("bETH-THETA")))
    // ),
    // "bBTC-THETA": BigNumber.from(2000).mul(
    //   BigNumber.from(10).pow(getAssetDecimals(getAssets("bBTC-THETA")))
    // ),
    "bBNB-THETA": BigNumber.from(50000).mul(BigNumber.from(10).pow(getAssetDecimals(getAssets("bBNB-THETA"))))
};
export var VaultFees = {
    // "bBUSD-ETH-P-THETA": {
    //   v1: {
    //     withdrawalFee: "1.0",
    //   },
    //   v2: {
    //     managementFee: "2",
    //     performanceFee: "10",
    //   },
    // },
    // "bETH-THETA": {
    //   v1: {
    //     withdrawalFee: "0.5",
    //   },
    //   v2: {
    //     managementFee: "2",
    //     performanceFee: "10",
    //   },
    // },
    // "bBTC-THETA": {
    //   v1: {
    //     withdrawalFee: "0.5",
    //   },
    //   v2: {
    //     managementFee: "2",
    //     performanceFee: "10",
    //   },
    // },
    "bBNB-THETA": {
        v1: {
            withdrawalFee: "0.5",
        },
        v2: {
            managementFee: "2",
            performanceFee: "10"
        }
    }
};
export var RibbonVaultMigrationMap = {
    // "bBTC-THETA": {
    //   v2: ["bBTC-THETA"],
    // },
    // "bETH-THETA": {
    //   v2: ["bETH-THETA"],
    // },
    "bBNB-THETA": {
        v2: ["bBNB-THETA"]
    }
};
export var v1ToV2MigrationMap = {
    // "bBTC-THETA": "bBTC-THETA",
    // "bETH-THETA": "bETH-THETA",
    "bBNB-THETA": "bBNB-THETA"
};
export var RibbonTokenAddress = isDevelopment()
    ? v1deployment.kovan.RibbonToken
    : v1deployment.mainnet.RibbonToken;
export var RibbonTokenBalancerPoolAddress = isDevelopment()
    ? v1deployment.kovan.RibbonTokenBalancerPool
    : // TODO: Update Mainnet Address
        "";
export var getERC20TokenAddress = function (token, chainId) {
    var network = NETWORKS[chainId];
    // console.log('getERC20TokenAddress ')
    // console.log(NETWORKS)
    // console.log(network)
    // console.log(addresses)
    // console.log(token)
    try {
        return isDevelopment()
            ? addresses[network].assets[token]
            : addresses[network].assets[token];
    }
    catch (error) {
        return undefined;
    }
};
export var LidoOracleAddress = isDevelopment()
    ? ""
    : "";
export var RibbonTreasuryAddress = (_f = {},
    _f[CHAINID.ETH_KOVAN] = "0xD380980791079Bd50736Ffe577b8D57A3C196ccd",
    _f[CHAINID.ETH_MAINNET] = "0xDAEada3d210D2f45874724BeEa03C7d4BBD41674",
    _f[CHAINID.BSC_TEST] = "0x3f1f1f9f5e3CC97820f4bc04816E67eFf18a0299",
    _f[CHAINID.BSC_MAINNET] = "0x5c481c791f215A17Bd73A87ee1e113e4EE0baB4E",
    _f);
export var PenaltyRewardsAddress = isDevelopment()
    ? governanceDeployment.bsc_test.RBNPenaltyRewards
    : governanceDeployment.bsc.RBNPenaltyRewards;
export var FeeDistributorAddress = isDevelopment()
    ? governanceDeployment.bsc_test.RBNFeeDistributor
    : governanceDeployment.bsc.RBNFeeDistributor;
export var VotingEscrowAddress = isDevelopment()
    ? governanceDeployment.bsc_test.RBNVotingEscrow
    : governanceDeployment.bsc.RBNVotingEscrow;
export var VotingEscrowDelegationProxyAddress = isDevelopment()
    ? governanceDeployment.bsc_test.RBNVotingEscrowDelegationProxy
    : governanceDeployment.bsc.RBNVotingEscrowDelegationProxy;
export var LiquidityTokenMinterAddress = isDevelopment()
    ? governanceDeployment.bsc_test.RBNVotingTokenMinter
    : governanceDeployment.bsc.RBNVotingTokenMinter;
export var LiquidityGaugeControllerAddress = isDevelopment()
    ? governanceDeployment.bsc_test.RBNVotingGaugeController
    : governanceDeployment.bsc.RBNVotingGaugeController;
export var READABLE_CHAIN_NAMES = (_g = {},
    _g[Chains.Ethereum] = "Ethereum",
    _g[Chains.Avalanche] = "Avalanche",
    _g[Chains.Solana] = "Solana",
    _g[Chains.NotSelected] = "No Chain Selected",
    _g[Chains.BSC] = "BSC",
    _g);
export var ENABLED_CHAINS = [
    // Chains.Ethereum,
    // Chains.Avalanche,
    // Chains.Solana,
    Chains.BSC,
];
export var CHAINS_TO_NATIVE_TOKENS = (_h = {},
    _h[Chains.Ethereum] = "WETH",
    _h[Chains.Avalanche] = "WETH",
    _h[Chains.Solana] = "WETH",
    // [Chains.Avalanche]: "WAVAX",
    // [Chains.Solana]: "SOL",
    _h[Chains.NotSelected] = "WETH",
    // [Chains.BSC]: "WBNB",
    _h[Chains.BSC] = "WBNB",
    _h);
export var CHAINS_TO_ID = (_j = {},
    _j[Chains.Ethereum] = isDevelopment() ? CHAINID.ETH_KOVAN : CHAINID.ETH_MAINNET,
    _j[Chains.Avalanche] = isDevelopment()
        ? CHAINID.AVAX_FUJI
        : CHAINID.AVAX_MAINNET,
    _j[Chains.BSC] = isDevelopment() ? CHAINID.BSC_TEST : CHAINID.BSC_MAINNET,
    _j);
export var ID_TO_CHAINS = (_k = {},
    _k[CHAINID.ETH_KOVAN] = Chains.Ethereum,
    _k[CHAINID.ETH_MAINNET] = Chains.Ethereum,
    _k[CHAINID.AVAX_FUJI] = Chains.Avalanche,
    _k[CHAINID.AVAX_MAINNET] = Chains.Avalanche,
    _k[CHAINID.BSC_TEST] = Chains.BSC,
    _k[CHAINID.BSC_MAINNET] = Chains.BSC,
    _k);
export var getSolanaVaultInstance = function (vaultOption) {
    var vaults = getSolanaAddresses().vaults;
    if (vaults[vaultOption])
        return new PublicKey(vaults[vaultOption]);
    throw new Error("No solana vault " + vaultOption);
};
var WEBAPP_SUBGRAPHS = [
    // ["v1", Chains.Ethereum],
    // ["v2", Chains.Ethereum],
    // ["v2", Chains.Avalanche],
    // ["v2", Chains.Solana],
    ["v2", Chains.BSC],
];
var TREASURY_SUBGRAPHS = [["v2", Chains.Ethereum]];
// console.log("isTreasury(): ", isTreasury());
export var SUBGRAPHS_TO_QUERY = isTreasury()
    ? TREASURY_SUBGRAPHS
    : WEBAPP_SUBGRAPHS;
// console.log("SUBGRAPHS_TO_QUERY: ", SUBGRAPHS_TO_QUERY);
// export const COINGECKO_BASE_URL = "https://api.coingecko.com/api/v3";
export var COINGECKO_BASE_URL = "https://price-service.bttcdn.com/api/v3";
export var COINGECKO_CURRENCIES = {
    WETH: "ethereum",
    ETH: "ethereum",
    // WBTC: "wrapped-bitcoin",
    // USDC: "usd-coin",
    // "USDC.e": "usd-coin",
    // yvUSDC: undefined,
    // stETH: "staked-ether",
    // wstETH: "wrapped-steth",
    // LDO: "lido-dao",
    // AAVE: "aave",
    // WAVAX: "avalanche-2",
    // sAVAX: "benqi-liquid-staked-avax",
    // PERP: "perpetual-protocol",
    // RBN: "ribbon-finance",
    // veRBN: undefined,
    // SOL: "solana",
    // APE: "apecoin",
    // WBNB: undefined,
    // WHT: undefined,
    USDC: 'binance-usd',
    // BUSD: 'binance-usd',
    WBTC: 'bitcoin',
    WBNB: 'binancecoin',
    BNB: 'binancecoin',
    // BNB: 'ethereum'
};
export var VaultNameMap = {
    // "bETH-THETA": "Weekly ETH Call",
    // "bBTC-THETA": "Weekly BTC Call",
    "bBNB-THETA": "Weekly BNB Call",
    // "bBUSD-ETH-P-THETA": "Weekly ETH Put",
    // "rBUSD-AVAX-P-THETA": "Weekly ETH Put"
};
//# sourceMappingURL=constants.js.map